import React from 'react';
import { Edit } from 'lucide-react';

/* ── Desktop: User Info Card ── */
const ProfileUserCard = ({ user, navigate }) => {
  return (
    <div className="profile-card profile-user-card">
      <div className="profile-avatar-wrapper">
        {user.avatar && (
          <img
            src={user.avatar}
            alt={user.name}
            className="profile-avatar"
            onError={(e) => {
              e.target.src =
                `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}`
            }}
          />
        )}          <button className="profile-edit-avatar" onClick={() => navigate("/profile-settings")}>
          <Edit size={16} />
        </button>
      </div>

      <h5 className="profile-user-name">{user.name}</h5>
      <p className="profile-user-email">{user.email}</p>
      <p className="profile-user-phone">{user.phone}</p>

      <div className="profile-stats">
        <div className="profile-stat">
          <span className="profile-stat-value">{user.stats.orders}</span>
          <span className="profile-stat-label">Orders</span>
        </div>
        <div className="profile-stat">
          <span className="profile-stat-value">{user.stats.favorites}</span>
          <span className="profile-stat-label">Favorites</span>
        </div>
        <div className="profile-stat">
          <span className="profile-stat-value">{user.stats.reviews}</span>
          <span className="profile-stat-label">Reviews</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileUserCard;